import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { mdiFormatListBulleted, mdiMagnify, mdiPlus, mdiViewGrid } from '@mdi/js'

import OrganizationsGridChip from '@/modules/Organizations/components/OrganizationsGridChip.vue'
import OrganizationsListChip from '@/modules/Organizations/components/OrganizationsListChip.vue'
import { createOrganization, fetchOrganizationsList } from '@/enitites/organization/api/endpoints'
import { Organization } from '@/modules/Organizations/types'
import { useDebounceFn } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationsPage',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const orgs = ref<Organization[]>([])
const currentUserOrgs = ref<Organization[]>([])
const isGridViewAllOrgs = ref(true)
const isGridViewCurrentUserOrgs = ref(true)

const getUserDB = computed(() => store.getters.getUserDB)
const createOrg = async () => {
  if (!getUserDB.value) {
    await router.push({
      name: 'Signup',
      query: { redirect: route.path },
    })
    return
  }

  const orgId = await createOrganization()
  if (orgId) {
    await router.push({ name: 'CreateOrganization', params: { id: orgId } })
  }
}

const orgListPayload = ref({
  pageNumber: 0,
  pageSize: 100,
  userId: 0,
  keyword: '',
})

const fetchOrgs = async () => {
  const response = await fetchOrganizationsList(orgListPayload.value)
  if (response) {
    orgs.value = response.items
  }
}

const debounceFetchOrgs = useDebounceFn(fetchOrgs, 500)
onMounted(() => {
  if (getUserDB.value) {
    currentUserOrgs.value = getUserDB.value.organizations
  }
  fetchOrgs()
})

return { __sfc: true,router, route, orgs, currentUserOrgs, isGridViewAllOrgs, isGridViewCurrentUserOrgs, getUserDB, createOrg, orgListPayload, fetchOrgs, debounceFetchOrgs, mdiFormatListBulleted, mdiMagnify, mdiPlus, mdiViewGrid, OrganizationsGridChip, OrganizationsListChip }
}

})